module.exports = __webpack_public_path__ + "img/paint_lew5dk.31ced8e1.svg";